import Constants from '@usas/ui-web/utils/Constants';
import { LmsHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_STATE = {
  isArrayLoading: false,
  isArrayLoaded: false,
  arrayData: [],
  message: '',
};

const getLmsAdminCourses = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };

    setState(newState);

    const url = `/Courses/admin`;
    LmsHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const options = arrayData.map((course) => {
            return { id: course.lmsCourseId, name: course.courseName };
          });
          options.unshift({ id: Constants.DEFAULT_ID, name: '--' });

          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const LmsAdminCoursesData = { INITIAL_STATE, getLmsAdminCourses };
export default LmsAdminCoursesData;